import React from 'react'

import ProductBlockSticker from './ProductBlockSticker'
import styles from './productBlockStickerLeft.css'

const ProductBlockStickerLeft = props => <ProductBlockSticker {...props} styles={styles} />

export default ProductBlockStickerLeft
